export default "__VITE_ASSET__DU6vwk7I__"